import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"
import _imports_0 from '@/assets/img/icon/dashboard-outline-darkgreen.png'
import _imports_1 from '@/assets/img/icon/danger-fill-darkgreen.png'
import _imports_2 from '@/assets/img/icon/wallet-fill-darkgreen.png'


const _hoisted_1 = { class: "md:flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "mt-4 border-grey-3 rounded-xl p-4" }
const _hoisted_4 = { class: "md:flex items-center justify-between" }
const _hoisted_5 = { class: "mt-4 grid md:grid-cols-4 gap-4" }
const _hoisted_6 = { class: "rounded-xl background-grey-2 p-4" }
const _hoisted_7 = { class: "text-lg font-bold" }
const _hoisted_8 = { class: "rounded-xl background-grey-2 p-4" }
const _hoisted_9 = { class: "text-lg font-bold" }
const _hoisted_10 = { class: "rounded-xl background-grey-2 p-4" }
const _hoisted_11 = { class: "text-lg font-bold" }
const _hoisted_12 = { class: "rounded-xl background-grey-2 p-4" }
const _hoisted_13 = { class: "text-lg font-bold" }
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = { class: "mt-4" }
const _hoisted_16 = { class: "md:flex justify-between gap-4" }
const _hoisted_17 = { class: "flex-1" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "md:grid grid-cols-4 gap-4" }
const _hoisted_20 = { class: "col-span-3 text-base" }
const _hoisted_21 = { class: "md:grid grid-cols-4 gap-4" }
const _hoisted_22 = { class: "col-span-3 text-base" }
const _hoisted_23 = { class: "md:grid grid-cols-4 gap-4" }
const _hoisted_24 = { class: "col-span-3 text-base" }
const _hoisted_25 = { class: "md:grid grid-cols-4 gap-4" }
const _hoisted_26 = { class: "col-span-3 text-base break-words" }
const _hoisted_27 = { class: "md:grid grid-cols-4 gap-4" }
const _hoisted_28 = { class: "col-span-3 text-base break-words" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "text-base break-words" }
const _hoisted_31 = { class: "flex-none" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "mt-4" }
const _hoisted_35 = { class: "violence-fine" }
const _hoisted_36 = { class: "md:flex items-center justify-between" }
const _hoisted_37 = {
  key: 0,
  class: "text-grey-5 text-sm font-semibold"
}
const _hoisted_38 = {
  key: 1,
  class: "mt-4 border-grey-3 rounded-lg"
}
const _hoisted_39 = { class: "w-full table-variant text-neutral500 px-3" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "w-250px break-all" }
const _hoisted_42 = { class: "break-all" }
const _hoisted_43 = { class: "break-words" }
const _hoisted_44 = { class: "break-all" }
const _hoisted_45 = { class: "break-all" }
const _hoisted_46 = { class: "break-all" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  colspan: "4",
  class: "text-primary font-bold"
}
const _hoisted_49 = { class: "flex mt-40px justify-end" }

import Card from 'primevue/card'
import { useRoute, useRouter } from 'vue-router'
import Button from 'primevue/button'
import Popper from 'vue3-popper'
import { computed, getCurrentInstance, onMounted, ref, watch, reactive } from 'vue'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { useStore } from 'vuex'
import apiUseCase from '@/usecase/apiUseCase'
import moment from 'moment'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import HjpSideBar from '@/views/components/sidebar/HjpSideBar.vue'
import numberFormat from '@/utils/helpers/numberFormat'
import apiAkdpUseCase from '@/usecase/apiAkdpUseCase'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import { getDynamicStatusBg, getDynamicStatusColor, getDynamicStatusName, getDynamicStatusIcon } from '@/utils/helpers/colorStatusLabel'
import AdjustmentForm from './AdjustmentForm.vue'
import EmployeeViolationHistory from './components/EmployeeViolationHistory.vue'
import cardStatusList from './cardStatusList'

const employeePenaltyEndpoint = 'talent/v1/employeePenalties'
const employeeEndpoint = 'talent/v1/employees'
const moduleStore = 'hjpTable'

export default /*@__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const router = useRouter()
const route = useRoute()
const store = useStore()
const idPrams = ref(null) as any
const dataPenaltyDetail = ref()
const dataEmployeeDetail = ref()
const dataPenaltyFine = ref([]) as any
const busScheduleDetail = ref('-')
const dataRowAdjustment = ref(null) as any
const isShowViolenceHistory = ref(false)
const selectedViolenceHistory = ref<number[]>([])
const canFinalizePenalty = computed(() => {
  const allowedRoles = ['administrator', 'penaltyfinalizer']
  const userRoles = store.state?.userProfile?.resource_access?.talent?.roles ?? []
  return allowedRoles.some((allowedRole) => userRoles.some(
    (userRole: unknown) => typeof userRole === 'string'
      && userRole.toLowerCase() === allowedRole
  ))
})

const getPenaltyAttributeValue = (key: string) => {
  const attributes = dataPenaltyDetail.value?.employeePenaltyAttributes
  if (!Array.isArray(attributes)) {
    return '-'
  }

  const attribute = attributes.find(
    (item: any) => (item.key ?? item.Key) === key
  )
  const value = attribute?.value ?? attribute?.Value
  if (value == null || value === '') {
    return '-'
  }

  if (key === 'BusSchedule') {
    return busScheduleDetail.value
  }

  if (typeof value === 'number') {
    return numberFormat(value)
  }

  if (typeof value === 'string') {
    const trimmedValue = value.trim()
    if (moment(trimmedValue, moment.ISO_8601, true).isValid()) {
      return moment.utc(trimmedValue, moment.ISO_8601).format('DD MMMM YYYY')
    }

    if (/^Rp\.?\s*/i.test(trimmedValue)) {
      const amount = Number(
        trimmedValue
          .replace(/^Rp\.?\s*/i, '')
          .replace(/[^\d,.-]/g, '')
          .replace(/\./g, '')
          .replace(',', '.')
      )
      return Number.isFinite(amount) ? rupiahFormat(amount) : trimmedValue
    }

    const numericValue = Number(trimmedValue)
    if (trimmedValue !== '' && Number.isFinite(numericValue)) {
      return numberFormat(numericValue)
    }
  }

  return value
}

const getBusScheduleDetail = async (busScheduleId: string) => {
  try {
    const { error, result, message } = await apiAkdpUseCase.get(
      `transaction/v2/TransactionPps?q=${busScheduleId}`
    )
    console.log('getBusScheduleDetail', result)
    if (!error) {
      const transactionPp = result[0]
      return `${transactionPp?.TrxId ?? '-'} | ${transactionPp?.VehicleRegNumber ?? '-'} | ${transactionPp?.CondecturName ?? '-'}`
    }
    $toast.add({
      severity: 'error',
      summary: 'Gagal memuat data PP',
      detail: message,
      life: 3000
    })
    return '-'
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal memuat data PP',
      detail: error,
      life: 3000
    })
    return '-'
  }
}

const isShowAdjustmentForm = computed({
  get: () => store.state[moduleStore].modal.show,
  set: (value) => {
    store.dispatch('setShowModal', value)
  }
})

const attrModalFinalizeConfirmation = reactive({
  show: false,
  title: 'Finalisasi Pelanggaran?',
  subTitle: 'Pelanggaran yang sudah difinalisasi tidak bisa diedit lagi. Cek ulang sebelum lanjut finaslisasi!',
  btnSubmitTitle: 'Finalisasi Pelanggaran',
  btnBackTitle: 'Kembali',
  subTitleHtml: false,
  imgContent: require('@/assets/img/modal-confirmation/finalize-penalty-card.png')
})

const attrModalCancelizeConfirmation = reactive({
  show: false,
  title: 'Batalkan Pelanggaran?',
  subTitle: 'Pelanggaran yang sudah dibatalkan tidak bisa diedit lagi. Cek ulang sebelum lanjut pembatalan!',
  btnSubmitTitle: 'Batalkan Pelanggaran',
  btnBackTitle: 'Kembali',
  subTitleHtml: false,
  imgContent: require('@/assets/img/modal-confirmation/finalize-penalty-card.png')
})

const onBack = () => {
  router.push({
    name: 'violation-card'
  })
}

const getDataEmployee = async (employeeId: string) => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${employeeEndpoint}/${employeeId}`).then((response) => {
    const { error, result } = response
    if (!error) {
      dataEmployeeDetail.value = result
    }
  })
  store.dispatch('hideLoading')
}

const getPenaltyDetail = async () => {
  store.dispatch('showLoading')
  const { error, result } = await apiUseCase.get(`${employeePenaltyEndpoint}/${idPrams.value}`)
  if (!error) {
    dataPenaltyDetail.value = result
    dataPenaltyFine.value = result.penaltyAdjustments
    const busSchedule = result.employeePenaltyAttributes?.find(
      (item: any) => (item.key ?? item.Key)?.toLowerCase() === 'busschedule'
    )
    const busScheduleId = busSchedule?.value ?? busSchedule?.Value
    busScheduleDetail.value = busScheduleId
      ? await getBusScheduleDetail(String(busScheduleId))
      : '-'
    getDataEmployee(result?.employeeId)
  }
  store.dispatch('hideLoading')
}

const hideAdjustmentForm = () => {
  isShowAdjustmentForm.value = false
  store.dispatch('storeRowDataTable', null)
  dataRowAdjustment.value = null
}

const showAdjustmentForm = (data: any = null) => {
  dataRowAdjustment.value = data
  store.dispatch('storeRowDataTable', dataRowAdjustment.value)
  isShowAdjustmentForm.value = true
}

const printPenaltyCardAct = async () => {
  store.dispatch('showLoading')
  try {
    const { error, result, message } = await apiUseCase.getBlob(`${employeePenaltyEndpoint}/${idPrams.value}/export`)
    if (error) {
      $toast.add({
        severity: 'error',
        summary: 'Dokumen gagal didownload',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
      return
    }

    let blob: Blob
    if (result instanceof Blob) {
      const signature = await result.slice(0, 5).text()
      if (signature === '%PDF-') {
        blob = result
      } else {
        // eslint-disable-next-line no-use-before-define
        blob = await createPdfBlob(await result.text())
      }
    } else {
      // eslint-disable-next-line no-use-before-define
      blob = await createPdfBlob(result)
    }

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `Kartu Pelanggaran (${dataPenaltyDetail.value?.penaltyTypeName ?? '-'}) ${dataEmployeeDetail.value?.fullName ?? '-'} (${moment().format('DD MMMM YYYY')}).pdf`
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.setTimeout(() => window.URL.revokeObjectURL(url), 1000)
    $toast.add({
      severity: 'success',
      detail: 'Data berhasil didownload',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Dokumen gagal didownload',
      detail: error instanceof Error ? error.message : 'Terjadi kesalahan saat mengunduh dokumen',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } finally {
    store.dispatch('hideLoading')
  }
}

const createPdfBlob = (value: unknown): Blob => {
  let fileData = value
  if (typeof fileData === 'string') {
    try {
      const parsed = JSON.parse(fileData)
      fileData = typeof parsed === 'string' ? parsed : parsed.Data ?? parsed.data
    } catch (error) {
      if (fileData.trimStart().startsWith('{')) {
        throw error
      }
    }
  }

  if (typeof fileData !== 'string') {
    throw new Error('Format dokumen dari server tidak valid')
  }

  const base64 = fileData
    .replace(/^data:application\/pdf;base64,/i, '')
    .replace(/\s/g, '')
  if (!base64.startsWith('JVBER')) {
    throw new Error('Data PDF dari server tidak valid')
  }

  const binary = window.atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index)
  }
  return new Blob([bytes], { type: 'application/pdf' })
}

const toEditPage = () => {
  const encryptPenaltyId = encryptDecriptMethods.encrypt(idPrams.value)
  router.push({
    name: 'violation-card-form',
    params: { id: encryptPenaltyId }
  })
}

const showViolenceHistory = () => {
  isShowViolenceHistory.value = !isShowViolenceHistory.value
  selectedViolenceHistory.value = []
}

const showFinalizePenaltyConfirmation = () => {
  attrModalFinalizeConfirmation.show = true
}

const hideDialogFinalizeConfirmation = () => {
  attrModalFinalizeConfirmation.show = false
}

const showCancelizePenaltyConfirmation = () => {
  attrModalCancelizeConfirmation.show = true
}

const hideDialogCancelizeConfirmation = () => {
  attrModalCancelizeConfirmation.show = false
}

const finalizePenaltyAct = async () => {
  store.dispatch('showLoading')
  await apiUseCase.putWithNoId(`${employeePenaltyEndpoint}/${idPrams.value}/finalize`, null).then((response) => {
    const { error, message, code } = response
    if (!error || code === 204) {
      $toast.add({
        severity: 'success',
        summary: 'Kartu Pelanggaran berhasil difinalisasi',
        group: 'bc',
        life: 3000
      })
      getPenaltyDetail()
    } else {
      $toast.add({
        severity: 'error',
        summary: 'Kartu Pelanggaran gagal difinalisasi',
        detail: message,
        group: 'bc',
        life: 3000
      })
    }
    hideDialogFinalizeConfirmation()
    if (isShowViolenceHistory.value) {
      showViolenceHistory()
    }
  })
  store.dispatch('hideLoading')
}

const cancelizePenaltyAct = async () => {
  store.dispatch('showLoading')
  await apiUseCase.putWithNoId(`${employeePenaltyEndpoint}/${idPrams.value}/cancel`, null).then((response) => {
    const { error, message, code } = response
    if (!error || code === 204) {
      $toast.add({
        severity: 'success',
        summary: 'Kartu Pelanggaran berhasil dibatalkan',
        group: 'bc',
        life: 3000
      })
      getPenaltyDetail()
    } else {
      $toast.add({
        severity: 'error',
        summary: 'Kartu Pelanggaran gagal dibatalkan',
        detail: message,
        group: 'bc',
        life: 3000
      })
    }
    hideDialogCancelizeConfirmation()
    showViolenceHistory()
  })
  store.dispatch('hideLoading')
}

watch(() => store.getters.reloadDataList, (val) => {
  if (val) {
    getPenaltyDetail()
  }
})

onMounted(() => {
  idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
  getPenaltyDetail()
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Kartu Pelanggaran',
      routeName: 'violation-card'
    },
    {
      title: 'Detail Kartu Pelanggaran',
      routeName: 'violation-card-form',
      params: { id: route.params.id }
    },
  ])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[9] || (_cache[9] = _createElementVNode("img", {
              src: _imports_0,
              alt: "X"
            }, null, -1)),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-xl font-bold" }, "Informasi Pelanggan", -1)),
            _createElementVNode("div", {
              style: _normalizeStyle({
                backgroundColor: _unref(getDynamicStatusBg)(_unref(cardStatusList), dataPenaltyDetail.value?.status)
              }),
              class: "flex items-center gap-2 rounded-lg px-4 py-1 ml-2 w-fit"
            }, [
              _createElementVNode("div", {
                style: _normalizeStyle({
                  color: _unref(getDynamicStatusBg)(_unref(cardStatusList), dataPenaltyDetail.value?.status),
                  backgroundColor: _unref(getDynamicStatusColor)(_unref(cardStatusList), dataPenaltyDetail.value?.status)
                }),
                class: "rounded-full px-1 py-1 flex items-center justify-center"
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(_unref(getDynamicStatusIcon)(_unref(cardStatusList), dataPenaltyDetail.value?.status))
                }, null, 2)
              ], 4),
              _createElementVNode("div", {
                style: _normalizeStyle({ color: _unref(getDynamicStatusColor)(_unref(cardStatusList), dataPenaltyDetail.value?.status) }),
                class: "text-sm font-semibold"
              }, _toDisplayString(_unref(getDynamicStatusName)(_unref(cardStatusList), dataPenaltyDetail.value?.status)), 5)
            ], 4)
          ]),
          _createVNode(_unref(Popper), {
            arrow: "",
            hover: String(dataPenaltyDetail.value?.status).toLowerCase() !== 'finalized',
            placement: "bottom",
            content: "Kartu belum difinalisasi"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: "inline-flex",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createVNode(_unref(Button), {
                  class: "btn-primary p-small-btn flex gap-x-2 mt-3",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (printPenaltyCardAct())),
                  disabled: String(dataPenaltyDetail.value?.status).toLowerCase() !== 'finalized'
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createElementVNode("i", { class: "pi pi-print text-white text-sm" }, null, -1),
                    _createElementVNode("p", { class: "text-white font-bold text-sm" }, _toDisplayString('Print Kartu'), -1)
                  ])),
                  _: 1,
                  __: [11]
                }, 8, ["disabled"])
              ])
            ]),
            _: 1
          }, 8, ["hover"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex items-center gap-4" }, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "X"
              }),
              _createElementVNode("div", { class: "text-lg font-bold" }, "Detail Pelanggaran")
            ], -1)),
            _createElementVNode("div", null, [
              (dataPenaltyDetail.value?.status.toLowerCase() == 'draft')
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 0,
                    class: "extra-submit-button p-small-btn flex gap-x-2 mt-3",
                    style: {"border-color":"#04776D"},
                    outlined: true,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (toEditPage()))
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createElementVNode("i", { class: "pi pi-pencil text-primary text-sm" }, null, -1),
                      _createElementVNode("p", { class: "text-primary font-bold text-sm" }, _toDisplayString('Edit Pelanggaran'), -1)
                    ])),
                    _: 1,
                    __: [12]
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-grey-5 text-sm font-semibold" }, "Nama Karyawan", -1)),
              _createElementVNode("div", _hoisted_7, _toDisplayString(dataEmployeeDetail.value?.fullName ?? '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-grey-5 text-sm font-semibold" }, "Jenis Pelanggaran", -1)),
              _createElementVNode("div", _hoisted_9, _toDisplayString(dataPenaltyDetail.value?.penaltyTypeName ?? '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-grey-5 text-sm font-semibold" }, "Divisi", -1)),
              _createElementVNode("div", _hoisted_11, _toDisplayString(dataEmployeeDetail.value?.employments.length > 0 ? dataEmployeeDetail.value?.employments[dataEmployeeDetail.value?.employments.length - 1].positionName : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-grey-5 text-sm font-semibold" }, "Tanggal Pelanggaran", -1)),
              _createElementVNode("div", _hoisted_13, _toDisplayString(dataPenaltyDetail.value?.createdAt ? _unref(moment)(dataPenaltyDetail.value?.createdAt).format('DD MMMM YYYY') : '-'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showViolenceHistory())),
              class: "text-primary text-base font-bold underline cursor-pointer w-fit"
            }, "Lihat Riwayat Pelanggaran")
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                (dataPenaltyDetail.value?.penaltyTypeName.toLowerCase() === 'kartu merah')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-grey-5 text-lg font-semibold" }, "Detail Pelanggaran", -1)),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[18] || (_cache[18] = _createElementVNode("div", null, "Tanggal Kejadian:", -1)),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(dataPenaltyDetail.value?.incidentDate ? _unref(moment)(dataPenaltyDetail.value?.incidentDate).format('DD MMMM YYYY') : '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _cache[19] || (_cache[19] = _createElementVNode("div", null, "Tanggal Tindakan:", -1)),
                        _createElementVNode("div", _hoisted_22, _toDisplayString(getPenaltyAttributeValue('DisciplinaryDate')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[20] || (_cache[20] = _createElementVNode("div", null, "PP Kejadian:", -1)),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(getPenaltyAttributeValue('BusSchedule')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _cache[21] || (_cache[21] = _createElementVNode("div", null, "Lokasi Kejadian:", -1)),
                        _createElementVNode("p", _hoisted_26, _toDisplayString(getPenaltyAttributeValue('Location')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _cache[22] || (_cache[22] = _createElementVNode("div", null, "Detail Kejadian:", -1)),
                        _createElementVNode("p", _hoisted_28, _toDisplayString(dataPenaltyDetail.value?.description ?? '-'), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-grey-5 text-lg font-semibold" }, "Catatan Pelanggaran", -1)),
                      _createElementVNode("p", _hoisted_30, _toDisplayString(dataPenaltyDetail.value?.description ?? '-'), 1)
                    ]))
              ]),
              _createElementVNode("div", _hoisted_31, [
                (dataPenaltyDetail.value?.evidenceUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: dataPenaltyDetail.value?.evidenceUrl,
                      width: "150",
                      class: "rounded-xl",
                      alt: "photo"
                    }, null, 8, _hoisted_32))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        (isShowViolenceHistory.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createVNode(EmployeeViolationHistory, { data: dataEmployeeDetail.value }, null, 8, ["data"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", {
              class: _normalizeClass(["border-grey-3 rounded-xl p-4", dataPenaltyFine.value.length === 0 ? 'background-grey-1' : ''])
            }, [
              _createElementVNode("div", _hoisted_36, [
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "flex items-center gap-4" }, [
                  _createElementVNode("img", {
                    src: _imports_2,
                    alt: "X"
                  }),
                  _createElementVNode("div", { class: "text-lg font-bold" }, "Informasi Denda")
                ], -1)),
                _createElementVNode("div", null, [
                  (dataPenaltyDetail.value?.status.toLowerCase() == 'draft')
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        class: "extra-submit-button p-small-btn flex gap-x-2 mt-3",
                        style: {"border-color":"#04776D"},
                        outlined: true,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (showAdjustmentForm()))
                      }, {
                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                          _createElementVNode("i", { class: "pi pi-plus text-primary text-sm" }, null, -1),
                          _createElementVNode("p", { class: "text-primary font-bold text-sm" }, _toDisplayString('Tambah Denda'), -1)
                        ])),
                        _: 1,
                        __: [25]
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              (dataPenaltyFine.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString('Belum ada denda untuk pelanggaran ini.')))
                : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("table", _hoisted_39, [
                      _cache[30] || (_cache[30] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "w-250px" }, "Kategori Denda"),
                          _createElementVNode("th", { class: "w-150px" }, "Nominal Denda"),
                          _createElementVNode("th", { class: "w-120px" }, "Tanggal Input"),
                          _createElementVNode("th", null, "Keterangan"),
                          _createElementVNode("th", { class: "w-75px" }, "Aksi")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (dataPenaltyFine.value.length === 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_40, _cache[27] || (_cache[27] = [
                              _createElementVNode("td", {
                                colspan: "5",
                                class: "text-center"
                              }, "Tidak ada data", -1)
                            ])))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataPenaltyFine.value, (dataFine) => {
                          return (_openBlock(), _createElementBlock("tr", { key: dataFine }, [
                            _createElementVNode("td", _hoisted_41, [
                              _createElementVNode("p", _hoisted_42, _toDisplayString(dataFine.penaltyAdjustmentCategoryName ?? '-'), 1)
                            ]),
                            _createElementVNode("td", _hoisted_43, _toDisplayString(`${dataFine.penaltyAdjustmentCategoryAdjustmentType && dataFine.penaltyAdjustmentCategoryAdjustmentType.toLowerCase() === 'decrement' ? '-' : ''} ${_unref(rupiahFormat)(dataFine.amount ?? 0)}`), 1),
                            _createElementVNode("td", null, _toDisplayString(_unref(moment).utc(dataFine.createdAt, _unref(moment).ISO_8601).format('DD/MM/YYYY')), 1),
                            _createElementVNode("td", _hoisted_44, [
                              _createElementVNode("p", _hoisted_45, _toDisplayString(dataFine.description), 1)
                            ]),
                            _createElementVNode("td", _hoisted_46, [
                              (dataPenaltyDetail.value?.status.toLowerCase() == 'draft')
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    class: "text-primary font-bold cursor-pointer break-all",
                                    onClick: ($event: any) => (showAdjustmentForm(dataFine))
                                  }, _cache[28] || (_cache[28] = [
                                    _createElementVNode("i", { class: "text-primary pi pi-pencil" }, null, -1),
                                    _createTextVNode(" Edit ")
                                  ]), 8, _hoisted_47))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("tfoot", null, [
                        _createElementVNode("tr", null, [
                          _cache[29] || (_cache[29] = _createElementVNode("td", { class: "text-primary font-bold" }, "Total Denda", -1)),
                          _createElementVNode("td", _hoisted_48, _toDisplayString(_unref(rupiahFormat)(dataPenaltyDetail.value?.totalAmount)), 1)
                        ])
                      ])
                    ])
                  ]))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (onBack()))
          }, {
            default: _withCtx(() => _cache[31] || (_cache[31] = [
              _createTextVNode("Kembali")
            ])),
            _: 1,
            __: [31]
          }),
          (dataPenaltyDetail.value?.status.toLowerCase() == 'draft' && canFinalizePenalty.value)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                class: "btn-primary mr-1",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (showFinalizePenaltyConfirmation()))
              }, {
                default: _withCtx(() => _cache[32] || (_cache[32] = [
                  _createTextVNode("Finalisasi")
                ])),
                _: 1,
                __: [32]
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(HjpSideBar, {
      show: isShowAdjustmentForm.value,
      onHideDialog: hideAdjustmentForm,
      canDelete: false
    }, _createSlots({ _: 2 }, [
      (isShowAdjustmentForm.value)
        ? {
            name: "form",
            fn: _withCtx(() => [
              _createVNode(AdjustmentForm, {
                data: dataRowAdjustment.value,
                existingFineAdjustment: dataPenaltyFine.value,
                currentTotalAmount: dataPenaltyDetail.value?.totalAmount ?? 0,
                penaltyId: idPrams.value
              }, null, 8, ["data", "existingFineAdjustment", "currentTotalAmount", "penaltyId"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["show"]),
    _createVNode(HjpConfirmationModal, {
      show: attrModalFinalizeConfirmation.show,
      title: attrModalFinalizeConfirmation?.title,
      subTitle: attrModalFinalizeConfirmation?.subTitle,
      btnSubmitTitle: attrModalFinalizeConfirmation?.btnSubmitTitle,
      btnBackTitle: attrModalFinalizeConfirmation?.btnBackTitle,
      subTitleHtml: attrModalFinalizeConfirmation?.subTitleHtml,
      imgContent: attrModalFinalizeConfirmation.imgContent,
      onHideDialog: hideDialogFinalizeConfirmation,
      onOnSubmit: _cache[7] || (_cache[7] = ($event: any) => (finalizePenaltyAct()))
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "btnBackTitle", "subTitleHtml", "imgContent"]),
    _createVNode(HjpConfirmationModal, {
      show: attrModalCancelizeConfirmation.show,
      title: attrModalCancelizeConfirmation?.title,
      subTitle: attrModalCancelizeConfirmation?.subTitle,
      btnSubmitTitle: attrModalCancelizeConfirmation?.btnSubmitTitle,
      btnBackTitle: attrModalCancelizeConfirmation?.btnBackTitle,
      subTitleHtml: attrModalCancelizeConfirmation?.subTitleHtml,
      imgContent: attrModalCancelizeConfirmation.imgContent,
      onHideDialog: hideDialogCancelizeConfirmation,
      onOnSubmit: _cache[8] || (_cache[8] = ($event: any) => (cancelizePenaltyAct()))
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "btnBackTitle", "subTitleHtml", "imgContent"])
  ]))
}
}

})